import React, { Component } from 'react';
import Header from './Header/Header';
import { Switch, Route , Link} from 'react-router-dom';
import ProposalForm from '../../Forms/ProposalForm/ProposalForm';

class FlashDelivery extends Component {
    constructor(props) {
        super(props);
        localStorage.setItem('catData',"");
    }
    render() {
        return (
            <div>
                <Header/>
                <section class="ovrfl">
                    <div class="container flash_con_pad">
                        <div class="row breadcrumb text-center trght">
                            <div class="col-md-12"> <a href="/"><span>Home</span></a> <i class="fa fa-angle-right"></i><span>Flash Delivery </span> </div>
                        </div>
                        <div class="row flash_pad">
                            <div class="panel-body">
                                <div class="col-md-8 custo_bg">
                                    <h3>GOOD BUSINESS DECISIONS TAKE TIME.IMPACTFUL RESEARCH NEED NOT.
                                    </h3>
                                    <p>
                                        Our clients requirements often come with very short deadlines. We believe in smart learning systems, the flat organization model, and efficient knowledge management to provide you accurate results during the time of your need. Our astute research process that includes an extensive network of key opinion leaders to drawexpertise from, efficient internal knowledge management databases, and the use of advanced data analytical tools provide us the capability to meet your deadlines.
                                    </p>

                                    <p class="colorchange flash_p_first">Do you have a research requirement with a deadline less than a week away?</p>

                                    <p class="colorchange">Do you need information in a presentation format with effective info-graphics rather than just data sheets with no comprehensible statistics?
                                    </p>

                                    <p class="colorchange">Are you facing challenges in developing a report for a specific business problem due to data limitations?
                                    </p>

                                    <p>Contact us to know how we successfully deliver actionable insights on time.</p>

                                </div>
                                <ProposalForm />
                            </div>

                        </div>

                        <div class="row">
                            <div class="col-md-10 col-md-push-1">
                                <div class="row flash_col  text-center">
                                    <h3>WHAT MAKES IT POSSIBLE</h3>
                                    <p>Lean Practice Structure + Geographic Advantage + Intelligent Databases</p>
                                </div>

                                <div class="row flash_rows_mrgs">
                                    <div class="col-md-8 flash_cols_br">
                                        <h4>Lean Structure</h4>
                                        <p>We understand that the term has become a cliché. organizations get trapped in set processes that make them slow. At Mordor Intelligence, we utilize the same processes to gain speed though multidisciplinary team approach focusing on effective work management</p>
                                    </div>

                                    <div class="col-md-2 flash_cols_plus">
                                        +
                                    </div>
                                    <div class="col-md-2">
                                    </div>
                                </div>

                                <div class="row flash_rows_mrgs">
                                    <div class="col-md-2">
                                    </div>
                                    <div class="col-md-8 flash_cols_br">
                                        <h4>geographic advantage</h4>
                                        <p>We understand that the term has become a cliché. organizations get trapped in set processes that make them slow. At Mordor Intelligence, we utilize the same processes to gain speed though multidisciplinary team approach focusing on effective work management</p>
                                    </div>

                                    <div class="col-md-2 flash_cols_plus">
                                        +
                                    </div>

                                </div>

                                <div class="row flash_rows_mrgs">
                                    <div class="col-md-2 flash_cols_plus">

                                    </div>
                                    <div class="col-md-2">

                                    </div>
                                    <div class="col-md-8 flash_cols_br">
                                        <h4>intelligent databases</h4>
                                        <p>We understand that the term has become a cliché. organizations get trapped in set processes that make them slow. At Mordor Intelligence, we utilize the same processes to gain speed though multidisciplinary team approach focusing on effective work management</p>
                                    </div>


                                </div>

                                <div class="row flash_rows_mrgs">
                                    <div class="col-md-6 ">

                                    </div>
                                    <div class="col-md-2  flash_cols_equal">
                                        =
                                    </div>
                                    <div class="col-md-4 flash_cols_br text-center">
                                        <h4 class="flash_cols_quick">QUICK DELIVERY</h4>
                                    </div>


                                </div>


                            </div>

                        </div>

                        <div class="row  text-center">
                            <p class="contact">Contact us  to know how we successfully deliver actionable insights on time.</p>
                            <Link to = "/contact-us" class="btn btn-primary contactus" role="button">contact us</Link>
                        </div>

                    </div>
                </section>

            </div>

        );
    }


}


export default FlashDelivery;


// WEBPACK FOOTER //
// ./src/consulting/FlashDelivery/FlashDelivery.js